import { render } from "./accordion-item.vue?vue&type=template&id=217c1c84"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"

import "./accordion-item.vue?vue&type=style&index=0&id=217c1c84&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__